import { ONBOARDING_STEPS } from "../constants";

const determineStepDescription = (step) => {
  switch(step){
    case ONBOARDING_STEPS.BasicInfo:
      return "Basic Info";
    case ONBOARDING_STEPS.Phone:
      return "Phone Number";
    case ONBOARDING_STEPS.Address:
      return "Address";
    case ONBOARDING_STEPS.Identity:
      return "Personal Information";
    case ONBOARDING_STEPS.Accounts:
      return "Link Bank";
    case ONBOARDING_STEPS.Confirm:
      return "Confirm";
    default:
      return "";
  }
};

export { determineStepDescription };